export const runtimeConfig = window.__APP_CONFIG__

if (!runtimeConfig) {
  throw new Error('Runtime configuration was not loaded.')
}
